import React, { useEffect } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { injectIntl, IntlProvider } from "react-intl";
import { ReactQueryConfigProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query-devtools';
import { connect } from "react-redux";
import { BrowserRouter, Redirect, Route } from "react-router-dom";
import FooterComponent from "./components/Footer/footer-new";
import HeaderComponent from "./components/Header/new-header";
import { default as UploadPresentation } from "./components/UploadPresentation";
import { default as UploadVideo } from "./components/UploadVideo";
import LoginRegister from "./containers/new/login-register";
import SpeakerData from './containers/speaker-data';
import en from "./react-intl/locale-data/en";
import fr from "./react-intl/locale-data/fr";


const ImpersonateRedirect = ({ match: { params }, history }) => {
  useEffect(() => {
    if (params.jwt) {
      localStorage.setItem("token", params.jwt.replace(/---/g, "."));
    }
    history.push("/");
  });

  return (
    <div className="section-padding-page">
      <Container>
        <Row>
          <Col mdOffset={4} md={4}>
            Please wait, while we redirect you.
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const UnauthenticatedApp = ({ intl, dispatch, user }) => {
  const [locale, setLocale] = React.useState(
    localStorage.getItem("locale") || "fr"
  );

  const getMessages = () => {
    switch (locale) {
      case "fr":
        return fr.messages;
      default:
        return en.messages;
    }
  };
  const _setLocale = (locale) => {
    localStorage.setItem("locale", locale);
    setLocale(locale);
    window.scrollTo(0, 0);
  };

  if (user && user.email) {
    return <Redirect to="/dashboard" />;
  }
  return (
    <IntlProvider locale={locale} messages={getMessages()} key={locale}>
      <>
        <ReactQueryDevtools initialIsOpen={false} />
        <ReactQueryConfigProvider config={{
          refetchOnWindowFocus: false,
          queries: {
            staleTime: Infinity
          }
        }}>
          <BrowserRouter onUpdate={() => window.scrollTo(0, 0)}>
            <HeaderComponent locale={locale} setLocale={_setLocale} />
            <Route exact path="/" component={LoginRegister} />
            <Route exact path="/signup" component={LoginRegister} />
            <Route exact path="/manage-presentations/:event_id/:speaker_id" component={UploadPresentation} />
            <Route exact path="/manage-videos/:event_id/:speaker_id" component={UploadVideo} />
            <Route exact path="/impersonate/:jwt" component={ImpersonateRedirect} />
            <Route exact path="/speaker-data/:event_id/:speaker_id/:module" render={(props) => <SpeakerData locale={locale} setLocale={setLocale} {...props} />} />
            <FooterComponent />
          </BrowserRouter>
        </ReactQueryConfigProvider>
      </>
    </IntlProvider>
  )
}

const mapStateToProps = (state) => ({
  user: state.user,
});


export default connect(mapStateToProps)(injectIntl(UnauthenticatedApp));